export const USERS_FIELD: any = {
 businessUnit : 'BUSINESS_UNIT',
galtMemberReference : 'GALT_MEMBER_REFERENCE',
userLegalEntity : 'LEGAL_ENTITY',
// newUserAccountsFlag : 'NEW_USER_ACCOUNTS_FLAG',
organizationalUnit : 'ORGANIZATIONAL_UNIT',
status : 'STATUS',
typeOfContact : 'TYPE_OF_CONTACT',
userAccountsEmail : 'USER_ACCOUNTS_EMAIL',
// userAccountsId : 'USER_ACCOUNTS_ID',
userAccountsName : 'USER_ACCOUNTS_NAME',
userRoleGalt : 'USER_ROLE_GALT',
// userRoleLocalChief : 'USER_ROLE_LOCAL_CHIEF',
userRoleOther : 'USER_ROLE_OTHER',
userRoleAuditSelfAssesment : 'USER_ROLE_AUDIT_SELF_ASSESMENT',
userRolePlannerTool : 'USER_ROLE_PLANNER_TOOL',
externalCompany : 'EXTERNAL_COMPANY',
btaType : 'BTA_TYPE',
workContractAvailability : 'WORK_CONTRACT_AVAILABILITY',
peopleManager : 'PEOPLE_MANAGER',
areaManager : 'AREA_MANAGER',
ghoContactType : 'GHO_CONTACT_TYPE',
null:'null'
};

